import React, { useState, useEffect, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Button } from 'reactstrap';
import { DatePicker } from 'components/common';
import { formatDate, formatDateTime, formatDateName, getTextColor } from 'services/util';
import styles from "assets/scss/task_management.module.css";
import { LocalForm } from 'react-redux-form';
import InputFile from 'components/common/InputFile';
import { Trans } from 'react-i18next';
import Select from 'react-select';
import { Multiselect } from "multiselect-react-dropdown";

function AssignedTaskModal({ task, onClose, onUpdate, fetchLabels, groups, buckets, userPermission, t }) {
    const [selectedLabels, setSelectedLabels] = useState([]);
    const [attachments, setAttachments] = useState();
    const [allowUpdate, setAllowUpdate] = useState(false);
    const [isLabelChange, setEditLabel] = useState(false);
    const labelOptionsRef = useRef();
    const defaultOptionsRef = useRef();
    

      const [taskState, setTaskState] = useState({
        task: task?.task
      });

      useEffect(() => {
        if (task?.task) {
          setTaskState(prevState => ({
            ...prevState.task,
            task: {
            bucket_task_name: task?.task?.bucket_task_name || '',
            progress: task?.task?.progress || '',
            priority: task?.task?.priority || '',
            start_date: task?.task?.start_date || '',
            end_date: task?.task?.end_date || '',
            selectedLabels: selectedLabels,
            allowUpdate: task?.task?.allow_update || false,
            updatedTaskStartDate: task?.task?.start_date || null,
            updatedTaskDueDate: task?.task?.end_date || null,
            repeat: task?.task?.repeat || false,
            notes: task?.task?.notes || '',
            description: task?.task?.description || '',
            comments: task?.task?.comments || '',
            attachments: {
                name: task?.task?.attachment?.name || '',
                file: task?.task?.attachment || '',
            } || {},
            addedBy: task?.task?.added_by,
            }
          }));
          updateOptions();
        }
      }, [task, fetchLabels]);

    const handleLabelSelect = (selectedOptions) => {
        const selectedIds = selectedOptions.map(option => option.value);
        setSelectedLabels(selectedIds);
    };

    const handleRemove = (selectedOptions) => {
        const selectedIds = selectedOptions.map(option => option.value);
        setSelectedLabels(selectedIds);
      };

    const updateOptions = () => {
        labelOptionsRef.current = fetchLabels?.map(label => ({
          value: label?.id,
          label: label?.label_name,
          color_code: label?.color_code,
        }));
      
        defaultOptionsRef.current = task?.task?.task_label?.map(id => {
          const label_obj = labelOptionsRef.current?.find(label => label.value === id?.id);
          return { 
            value: label_obj?.value,
            label: label_obj?.label,
            color_code: label_obj?.color_code || '' 
          };
        });
      };

    const labelOptions = labelOptionsRef.current;
    const defaultOptions = defaultOptionsRef.current;

    const updateTaskState = (key, value) => {
    const keys = key.split('.');
    
    setTaskState(prevState => {
        let updatedState = { ...prevState };

        let temp = updatedState;
        for (let i = 0; i < keys.length - 1; i++) {
        if (!temp[keys[i]]) temp[keys[i]] = {};
        temp = temp[keys[i]];
        }
        temp[keys[keys.length - 1]] = value;

        return updatedState;
    });
    };

    const handleUpdate = () => {
        const updatedTask = {
            ...task,
            bucket_task_name: taskState?.task?.bucket_task_name,
            start_date: taskState?.task?.start_date ? taskState?.task?.start_date : null,
            end_date: taskState?.task?.end_date ? taskState?.task?.end_date : null,
            task_label: selectedLabels?.length > 0 ? selectedLabels : defaultOptions?.map(label => label?.value),
            // planner_bucket: selectedBucket?.id,
            progress: taskState?.task?.progress,
            priority: taskState?.task?.priority,
            repeat: taskState?.task?.repeat,
            notes: taskState?.task?.notes,
            attachment: attachments?.attachment,
            comments: taskState?.task?.comments,
            added_by: taskState?.task?.addedBy,
            description: taskState?.task?.description,
            employees_group: taskState?.selectedGroup,
            allow_update: taskState?.task?.allowUpdate
        };
        onUpdate(updatedTask);
        onClose();
    };

    const selectedGroupObject = groups.find(group => group.id === taskState?.selectedGroup);
    const multiSelectStyle = {
        chips: { background: '#72B566' },
      };

    return (
        <Modal isOpen={true} toggle={onClose} className={styles.update_task_modal} style={{ maxWidth: '800px', minWidth: '300px' }}>
            <ModalHeader toggle={onClose}>
                <div className={styles.modal_header_content}>
                    <span className={styles.task_title}><Trans>Task Details</Trans></span>
                </div>
            </ModalHeader>
            <ModalBody style={{ margin: '0 30px' }}>
                <div className={styles.form_group}>
                    <input
                    type="text"
                    className={`${styles.title_input}  ${task?.task?.progress === "Completed" ? styles.inputField : ''}`}
                    value={taskState?.task?.bucket_task_name}
                    // onChange={(e) => updateTaskState("task.bucket_task_name", e.target.value)}
                    // disabled={!taskState?.task?.allow_update}
                />
                </div>
                <div className={styles.form_group}>
                    <label><Trans>Last changed</Trans>: {formatDateTime(task?.task?.updated_at)}</label>
                </div>

                {!isLabelChange ?  
                  <div className='d-flex justify-content-start align-items-center'>
                    <div className={styles.form_group}>
                    <label><strong><Trans>Selected Labels</Trans></strong></label>
                    <div className={styles.selectedLabels}>
                        {defaultOptions?.map((i) => (
                            <span 
                                key={i?.id} 
                                style={{
                                    borderRadius: '10%', 
                                    backgroundColor: i?.color_code || '',
                                    marginRight: "3px",
                                    color: getTextColor(i?.color_code)
                                }} 
                                className='p-2'>
                                {i?.label}
                            </span>
                        ))}
                    </div>
                </div>
                <div className='mx-auto'/>
                <div>
                  <Button size='sm' color='primary' onClick={() => setEditLabel(!isLabelChange)}><i className='fa fa-edit' /></Button>
                </div>
                </div>
                :
                <div className={styles.form_group}>
                    <label><strong><Trans>Task Label</Trans></strong></label>
                    <div className={styles.groupSelectContainer}>
                    <Multiselect
                        options={labelOptions}
                        selectedValues={defaultOptions}
                        style={multiSelectStyle}
                        onSelect={handleLabelSelect}
                        onRemove={handleRemove}
                        displayValue="label"
                        emptyRecordMsg={'No options available'}
                        selectionLimit={10}
                        avoidHighlightFirstOption
                    />
                    </div>
                </div>
                }
                <div className={styles.form_row}>
                    <div className={`${styles.selectField} ${styles.group_select} ${styles.notes_area}`}>
                        <label><strong><Trans>Bucket</Trans></strong></label>
                            <Select
                                value={{ label: taskState?.planner_bucket?.bucket_name, value: taskState?.planner_bucket?.id }}
                                simpleValue
                                disabled
                            />
                    </div>
                    <div className={styles.form_group}>
                        <label><strong><Trans>Progress</Trans></strong></label>
                        <select disabled={!taskState?.task?.allowUpdate} className={`${styles.selectField} ${styles.notes_area}`} value={taskState?.task?.progress} onChange={e => updateTaskState('task.progress', e.target.value)}>
                            <option value="Not Started">{t('Not Started')}</option>
                            <option value="In Progress">{t('In Progress')}</option>
                            <option value="Completed">{t('Completed')}</option>
                        </select>
                    </div>
                    <div className={styles.form_group}>
                        <label><strong><Trans>Priority</Trans></strong></label>
                        <select disabled className={`${styles.selectField} ${styles.notes_area}`} value={taskState?.task?.priority} onChange={e => updateTaskState('task.priority', e.target.value)}>
                            <option value="Urgent">{t('Urgent')}</option>
                            <option value="Important">{t('Important')}</option>
                            <option value="Medium">{t('Medium')}</option>
                            <option value="Low">{t('Low')}</option>
                        </select>
                    </div>
                </div>
                <div className={styles.form_row}>
                    <div className={`${styles.dates_field} ${styles.form_group}`}>
                        <label><strong><Trans>Start Date</Trans></strong></label>
                        <LocalForm>
                            <DatePicker
                                onChange={date => updateTaskState('task.start_date', date)}
                                type="date"
                                model=".date"
                                placeholderText="Select start date"
                                selected={taskState?.task?.start_date || null}
                                defaultValue={taskState?.task?.start_date || ""}
                                disabled
                            />
                        </LocalForm>
                    </div>
                    <div className={`${styles.dates_field} ${styles.form_group}`}>
                        <label><strong><Trans>Due Date</Trans></strong></label>
                        <LocalForm>
                            <DatePicker
                                onChange={date => updateTaskState('task.end_date', date)}
                                type="date"
                                model=".date"
                                placeholderText="Select due date"
                                selected={taskState?.task?.end_date || null}
                                defaultValue={taskState?.task?.end_date || ""}
                                className={`${styles.selectField} ${styles.notes_area}`}
                                disabled
                            />
                        </LocalForm>
                    </div>
                    <div className={styles.form_group}>
                        <label><strong><Trans>Repeat</Trans></strong></label>
                        <select disabled className={`${styles.selectField} ${styles.notes_area}`} value={taskState?.task?.repeat} onChange={(e) => updateTaskState("task.repeat", e.target.value)}>
                            <option value="Does not repeat">{t('Does not repeat')}</option>
                            <option value="Weekdays">{t('Week Days')}</option>
                            <option value="Daily">{t('Every Day')}</option>
                            <option value="Weekly">{t('Every Week')}</option>
                            <option value="Monthly">{t('Every Month')}</option>
                            <option value="Yearly">{t('Every Year')}</option>
                        </select>
                    </div>
                </div>
                <div className={styles.form_group}>
                    <label><strong><Trans>Notes</Trans></strong></label>
                    <textarea disabled className={`${styles.notes_area} ${styles.wider_textarea}`} placeholder='Your Notes of the task here' value={taskState?.task?.notes} onChange={(e) => updateTaskState("task.notes", e.target.value)} />
                </div>
                <div className={styles.form_group}>
                    <label><strong><Trans>Description</Trans></strong></label>
                    <textarea disabled className={styles.notes_area} placeholder='Your Description of the task here' value={taskState?.task?.description} onChange={(e) => updateTaskState("task.description", e.target.value)} />
                </div>
                <div className={styles.form_group}>
                    <FormGroup className="pb-2 pt-3">
                        <label htmlFor=""><strong><Trans>Attachment</Trans></strong></label>
                        <InputFile disabled={true} file={taskState || task.task?.attachment || ""} setData={setAttachments}></InputFile>
                    </FormGroup>
                </div>
                <div className={styles.form_group}>
                    <label><strong><Trans>Comments</Trans></strong></label>
                    <textarea className={styles.notes_area} placeholder='Finished the task? Let your team know you have finished the task and write your comments here' value={taskState?.task?.comments} onChange={(e) => updateTaskState("task.comments", e.target.value)} />
                </div>
                <div className={styles.form_group}>
                    <label><strong><Trans>Added By</Trans></strong></label>
                    <div>{task.task?.added_by?.full_name}</div>
                    <div>{formatDateTime(task.task?.created_at)}</div>
                </div>
                {userPermission && (
                    <div className={styles.form_group}>
                        <label><strong><Trans>Allow Update</Trans></strong></label>
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="allowUpdateCheckbox"
                                checked={allowUpdate}
                                onChange={() => setAllowUpdate(!allowUpdate)}
                            />
                            <label className="form-check-label" htmlFor="allowUpdateCheckbox"><Trans>Allow</Trans></label>
                        </div>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                    <>
                        <button onClick={handleUpdate} className="btn btn-primary"><Trans>Update Task</Trans></button>
                        <button onClick={onClose} className="btn btn-secondary"><Trans>Cancel</Trans></button>
                    </>
            </ModalFooter>
        </Modal>
    );
}

export default AssignedTaskModal;